<template>
  <div>
    <div class="crumbs-navigate">
      <div class="wrapper">
        <h3>
          {{liveInfo.subject}}
          <span class="badge-success badge-sm">{{$t(status)}}</span>
        </h3>
        <ct-row class="second">
          <ct-col :span="12">
            {{liveInfo.duration}}
            <span class="divider-v" v-show="liveInfo.teachers"></span>
            {{liveInfo.teachers}}
          </ct-col>
          <ct-col :span="12" style="text-align: right">
            <ct-button
              type="text_secondary"
              @click="handleClickPingfen"
              :aria-disabled="!canPingfen"
              :disabled="!canPingfen"
              class="inline-button"
            >
              <ct-icon name="pingfen"></ct-icon> Score this lesson
            </ct-button>
            <ct-link
              type="text_secondary"
              class="inline-button"
              :href="subclass.course_ware"
              target="_blank"
              v-if="canNotes"
              download
              aria-disabled="false"
            >
              <ct-icon name="xiazai"></ct-icon> Class notes
            </ct-link>
            <ct-button
              type="text_secondary"
              class="inline-button"
              v-else
              disabled
              aria-disabled="true"
            >
              <ct-icon name="xiazai"></ct-icon> Class notes
            </ct-button>
          </ct-col>
        </ct-row>
      </div>
    </div>
    <div class="sub-content-container">
      <transition name="fadeInUp">
        <router-view></router-view>
      </transition>
    </div>
    <pingfen-modal
    :visible.sync="visiblePingfen"
    :class-id="liveId"
    :subclass-id="subId"
    v-if="canPingfen"
    @close="closedModal"
    :logined="isAuthenticated"
    ></pingfen-modal>
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import api from '@ca/api'
import moment from 'moment'
import PingfenModal from './sub/PingfenModal'
import { vueAppPassportDomin, vueAppDomin } from '@ca/constants/variables.js'

export default {
  name: 'LiveRoom',
  components: {
    'pingfen-modal': PingfenModal
  },
  data () {
    const isReplay = this.$route.name === 'live-replay'
    return {
      live_play_url: {
        // 'flv': 'ad culpa',
        // 'm3u8': 'est laboris',
        // 'rtmp': 'labore culpa'
      },
      visiblePingfen: false,
      replay_play_url: null,
      replay_play_auth: {},
      useEncrypt: null,
      status: isReplay ? 'course.Replay' : 'course.Live',
      subclass: {
        subclass_title: '',
        subclass_id: null,
        teachers: '',
        begin_at: null,
        end_at: null,
        course_ware: ''
      }
    }
  },
  methods: {
    ...mapActions(['changeDomTitle']),
    goRoute (routePath) {
      this.$router.push(routePath)
    },
    closedModal () {
      this.visiblePingfen = false
    },
    showPingfen () {
      if (this.isAuthenticated && !this.isAdminRole) {
        this.visiblePingfen = true
      }
    },
    handleClickPingfen () {
      if (this.isAuthenticated && !this.isAdminRole) {
        this.visiblePingfen = true
      } else {
        window.location.href = vueAppPassportDomin + 'Login?return_url=' + window.location.href
      }
    },
    enterClass () {
      api.enterClass({
        data: {
          class_id: Number(this.liveId),
          subclass_id: Number(this.subId)
        }
      })
        .then(res => {
          if (res.data && res.data.code === 1) {
            if (res.data.data.subclass) {
              this.subclass = res.data.data.subclass
            }
            // 直播推流地址
            if (res.data.data.live_play_url) {
              this.live_play_url = res.data.data.live_play_url || {}
            }
            // 回放地址
            if (res.data.data.replay_play_url) {
              this.replay_play_url = res.data.data.replay_play_url || []
            }
            // 回放加密
            if (res.data.data.replay_play_auth) {
              this.replay_play_auth = res.data.data.replay_play_auth || {}
            }
            this.useEncrypt = res.data.data.replay_type === 'encryption'
          } else if (res.data && res.data.code === -1) {
            this.msgDialog(res.data.error)
          } else if (res.data && res.data.code === 90606) {
            this.msgDialog('Sorry, this lesson doesn’t begin to broadcast and doesn’t allow you to access yet')
          } else {
            this.$toast(res.data.error)
          }
        }, () => {
          this.$toast('Oops, something went wrong or this order has become invalid. Please go back to restart the process.')
        })
    },
    msgDialog (msg) {
      this.$confirm({
        message: msg,
        cancelButton: true,
        cancelButtonText: 'Cancel',
        confirmButtonText: 'Got it',
        closed: (resovle) => {
          this.$router.push({
            name: 'liveCourseDetail',
            params: {
              origin: this.liveId
            }
          })
        }
      })
    },
    judgeAuth () {
      api
        .getCourseAuth({
          params: {
            class_id: this.liveId,
            subclass_id: this.subId
          }
        })
        .then(res => {
          if (res.data) {
            let { error, code } = res.data
            if (code === 1) {
              this.enterClass()
            } else if (code === 90603) {
              this.msgDialog('This lesson need to be payed before learning.')
            // status is 401
            // } else if (code === 100000) {
            //   window.location = `${vueAppPassportDomin}Login?return_url=${vueAppDomin}${this.$route.path}`
            } else if (code === 90606) {
              this.msgDialog('Sorry, this lesson doesn’t begin to broadcast and doesn’t allow you to access yet')
            } else if (code === -1) {
              this.$router.push({
                name: 'notFound'
              })
            } else {
              this.$toast(error)
            }
          }
        }, (res) => {
          if (res.response.data && res.response.data.code === 100000) {
            window.location = `${vueAppPassportDomin}Login?return_url=${vueAppDomin}${this.$route.path}`
          }
        })
    }
  },
  computed: {
    ...mapGetters(['isAuthenticated']),
    canPingfen () {
      return false || (!!this.subclass.subclass_id && !this.isAdminRole)
    },
    canNotes () {
      return false || !!this.subclass.course_ware
    },
    liveInfo () {
      const {
        subclass_title: subject,
        teachers,
        begin_at: startAt,
        end_at: endAt
      } = this.subclass
      const start = moment(startAt * 1000).format('HH:mm')
      const end = moment(endAt * 1000).format('HH:mm MMM Do')
      this.changeDomTitle(subject + ' |  Course System')
      return {
        subject,
        teachers,
        status,
        duration: this.$t('course.LiveDuring', { start, end })
      }
    },
    liveId () {
      return Number(this.$route.params.liveId)
    },
    subId () {
      return Number(this.$route.params.subId)
    },
    isReplay () {
      return this.$route.name === 'live-replay'
    }
  },
  mounted () {
    this.judgeAuth()
  },
  destroyed () {
  }
}
</script>

<style lang="scss" scoped>
$navigate-height: 76px;
.crumbs-navigate {
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 2px 14px 0px rgba(79, 117, 162, 0.07);
  padding-top: 10px;
  padding-bottom: 10px;
  h3 {
    font-family: SFProDisplay-Medium, SFProDisplay;
    margin-bottom: 5px;
  }
  .second {
    font-size: 14px;
    font-family: SFProText-Regular, SFProText;
    font-weight: 400;
    color: #a3b1bf;
    line-height: 40px;
  }
}
.wrapper {
  position: relative;
}
.sub-content-container {
  margin-top: 34px;
}

.badge-sm {
  font-size: 12px;
  font-family: SFProDisplay-Regular, SFProDisplay;
  font-weight: 400;
  display: inline-block;
  padding: 3px 6px;
  line-height: 14px;
  vertical-align: middle;
  margin-top: -3px;
}
.inline-button {
  padding: 12px 0;
  line-height: 1;
  font-size: 16px;
  .ct-icon-xiazai,.ct-icon-pingfen{
    font-size: 18px;
  }
  &[disabled=disabled],
  &:disabled {
    color: #a3b1bf;
    background: transparent;
    cursor: not-allowed;
  }
}
.inline-button + .inline-button {
  margin-left: 40px;
}
.divider-v {
  width: 1px;
  font-size: inherit;
  display: inline-block;
  margin: -3px 10px 0;
  background: #a3b1bf;
  height: 14px;
  vertical-align: middle;
}
</style>
